import { Box } from "@mui/material";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  CreateShopLogoUpload,
  CreateShopStepHeading,
  FloatingTextField,
  SelectField,
} from "@/components/Molecules";
import type { CreateShopInfoStepProps } from "./CreateShopInfoStep.types";
import * as styles from "./CreateShopInfoStep.styles";

export function CreateShopInfoStep({
  infoForm,
  logoPreview,
  onLogoSelect,
  categoryOptions,
  businessTypeOptions,
}: CreateShopInfoStepProps) {
  const { t } = useTranslation(["shops", "settings"]);

  return (
    <>
      <CreateShopStepHeading
        titleKey="create.info.title"
        subtitleKey="create.info.subtitle"
        mobileSubtitleKey="create.info.mobileSubtitle"
      />

      <CreateShopLogoUpload logoPreview={logoPreview} onLogoSelect={onLogoSelect} />

      <Box sx={styles.stack}>
        <FloatingTextField
          label={t("settings:general.name")}
          placeholder={t("settings:general.name")}
          error={Boolean(infoForm.formState.errors.name)}
          helperText={infoForm.formState.errors.name?.message}
          {...infoForm.register("name")}
        />

        <Controller
          name="category"
          control={infoForm.control}
          render={({ field }) => (
            <SelectField
              label={t("settings:general.category")}
              options={categoryOptions.map((option) => ({
                value: option.value,
                label: t(`settings:${option.labelKey}`),
              }))}
              value={field.value ?? ""}
              onChange={(event) => field.onChange(event.target.value)}
            />
          )}
        />

        <Box sx={styles.grid}>
          <Controller
            name="business_type"
            control={infoForm.control}
            render={({ field }) => (
              <SelectField
                label={t("settings:general.businessType")}
                options={businessTypeOptions.map((option) => ({
                  value: option.value,
                  label: t(`settings:${option.labelKey}`),
                }))}
                value={field.value ?? ""}
                onChange={(event) => field.onChange(event.target.value)}
              />
            )}
          />

          <FloatingTextField
            label={t("settings:general.warehouseAddress")}
            placeholder="شهر، آدرس تقریبی"
            {...infoForm.register("warehouse_address")}
          />
        </Box>

        <FloatingTextField
          label={t("settings:general.description")}
          placeholder="مثلا فروش انواع لوازم آرایشی اورجینال"
          {...infoForm.register("description")}
        />
      </Box>
    </>
  );
}
